export function getAppId() {
    const userAgent = navigator.userAgent
    if (userAgent.includes('MicroMessenger')) {
        let viewport = document.querySelector('meta[name=viewport]')
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')

        // 动态加载微信JS-SDK
        const wxpayScript = document.createElement('script')
        wxpayScript.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
        wxpayScript.onload = () => {
            console.log('微信JS-SDK加载成功')
        }
        document.body.appendChild(wxpayScript)
    } else if (userAgent.includes('AlipayClient')) {
        console.log('支付宝')
            // 动态加载支付宝JS-SDK
        const alipayScript = document.createElement('script')
        alipayScript.src = 'https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js'
        alipayScript.onload = () => {
            console.log('支付宝JS-SDK加载成功')
        }
        return document.body.appendChild(alipayScript)
    } else {
        return 'Unknown' // 未知客户端
    }
}